export default "__VITE_ASSET__Bi6hmJ$y__"